import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import styled from 'styled-components';

import { Section, Title } from '../shared';

import SelectCountry from './SelectCountry';
import getRankingComponent from './getRankingComponent';

import { maxWidth } from '../../helpers/media-queries';

const Wrapper = styled.div `
    &:before, &:after {
        content: '';
        position: absolute;
        background-repeat: no-repeat;
        background-size: contain;
    }

    &:before {
        top: 10px;
        left: 10px;
        background-image: url(./static/images/ranking/bright-1.png);
        height: 4px;
        width: 80px;
    }

    &:after {
        bottom: 10px;
        right: 10px;
        background-image: url(./static/images/ranking/bright-2.png);
        height: 84px;
        width: 112px;
    }

    & .ranking-wrapper > h3 {
        display: flex;
        justify-content: center;
        align-items: center;

        ${maxWidth.lg} {
            padding-bottom: 0.5em;
            position: relative;
        }
    }

    & .ranking-wrapper > h3:before, & .ranking-wrapper > h3:after {
        content: '';
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url(./static/images/ranking/gold.png);
        width: 68px;
        margin: 0 10px;
        height: 0.5em;
        background-position: center;
        background-size: auto 15px;

        ${maxWidth.lg} {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 44%;
            background-position: center right;
        }
        
    }

    & .ranking-wrapper > h3:after {
        transform: rotate(180deg);

        ${maxWidth.lg} {
            right: 0;
            left: auto;
            background-position: center right;
        }
    }
`;

const styles = ({ palette, sizes }) => ({
    root: {
        '& h3': {
            textAlign: 'center',
            color: '#ffffff',
        },

        '& .wrapper': {        
            position: 'relative',
            borderStyle: 'solid',
            borderWidth: '32px 32px 40px 32px',
            borderImage: 'url(./static/images/ranking/border.png) 110 139 137 137 round',

            [maxWidth.lg]: {
                borderWidth: '22px 22px 30px 22px',
            },
    
        },

        '& .ranking-wrapper': {
            backgroundColor: 'black',
            backgroundImage: 'url(./static/images/ranking/grid.png)',
            backgroundSize: '15px', 
            padding: `${sizes.baseSize}px ${sizes.baseSize}px `,

            [maxWidth.lg]: {
                borderWidth: '22px 22px 30px 22px',
            },
            
            [maxWidth.sm]: {
                padding: '25px 0',
            },
        }
    }
});

const mapper = (stores) => ({
    intl: stores.intl.dictionary,
    ranking: stores.ranking.ranking,
})

class Ranking extends Component {
    render() {
        const { intl, classes, ranking } = this.props;

        let status = 'default';

        if (!ranking || !ranking.length) status = 'placeholder';

        const Component = getRankingComponent(status);
        
        return (
            <Section className={classes.root} id="sesion-classificacion">
                <Wrapper className="wrapper">
                    <div className="ranking-wrapper">
                        <Title>{intl['LOCALE.RANKING']}</Title>
                        <SelectCountry />
                        <Component />
                    </div>
                </Wrapper>
            </Section>
        )
    }
}

export default inject(mapper)(
    withStyles(styles)(Ranking)
);